__turbopack_context__.v({
  "button": "styles-module-scss-module__Yrbxrq__button",
  "button__label": "styles-module-scss-module__Yrbxrq__button__label",
  "button__label__modHidden": "styles-module-scss-module__Yrbxrq__button__label__modHidden",
  "button__modDanger": "styles-module-scss-module__Yrbxrq__button__modDanger",
  "button__modFullWidth": "styles-module-scss-module__Yrbxrq__button__modFullWidth",
  "button__modLg": "styles-module-scss-module__Yrbxrq__button__modLg",
  "button__modSm": "styles-module-scss-module__Yrbxrq__button__modSm",
  "button__modSquare": "styles-module-scss-module__Yrbxrq__button__modSquare",
  "button__modXs": "styles-module-scss-module__Yrbxrq__button__modXs",
  "button__spinner": "styles-module-scss-module__Yrbxrq__button__spinner",
  "button__typeLink": "styles-module-scss-module__Yrbxrq__button__typeLink",
  "button__typePrimary": "styles-module-scss-module__Yrbxrq__button__typePrimary",
  "button__typeSecondary": "styles-module-scss-module__Yrbxrq__button__typeSecondary",
});
